import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";

export const UserFragment = gql`
  fragment UserFragment on User {
    id
    email
    status
    roles
    createdAt
    updatedAt
  }
`;




export const get = gql`
  query UserGet($domain: String!, $orgId: String!, $email: String!) {
    viewer {
      id
      account {
        id
        ...AccountFragment
        domains {
          id
          get(domain: $domain){
            id
            organizations {
              id
              get(orgId: $orgId) {
                id
                users {
                  id
                  get(email: $email){
                    ...UserFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${UserFragment}
`;


export const list = gql`
  query UserList($domain: String!, $orgId: String!, $input: ListInput) {
    viewer {
      id
      account {
        id
        domains {
          id
          get(domain: $domain){
            id
            organizations {
              id
              get(orgId:$orgId) {
                id
                users {
                  list(input: $input) {
                    id
                    last
                    items {
                      ...UserFragment
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${UserFragment}
`;



export const invite = gql`
  mutation UserNew($domain: String!, $orgId: String!, $input: UserInputInvite!) {
    viewer {
      account {
        domains {
          get(domain: $domain){
            organizations {
              get(orgId:$orgId) {
                users {
                  invite(input: $input) {
                    ...UserFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${UserFragment}
`;



export const edit = gql`
  mutation UserEdit($domain: String!, $orgId: String!, $email: String!, $input: UserInputUpdate! ) {
    viewer {
      account {
        domains {
          get(domain: $domain){
            organizations {
              get(orgId:$orgId) {
                users {
                  get(email: $email) {
                    update(input: $input){
                      ...UserFragment
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${UserFragment}
`;


export const remove = gql`
  mutation UserRemove($domain: String!, $orgId: String!, $email: String! ) {
    viewer {
      account {
        domains {
          get(domain: $domain){
            organizations {
              get(orgId:$orgId) {
                users {
                  get(email: $email) {
                    remove
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;


export const update = ({ domain, orgId }) => (cache) => {
  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`${domain}/${orgId}/user/queries`)) {
      cache.data.delete(key);
    }
  });
};
